import { render, staticRenderFns } from "./analytics.vue?vue&type=template&id=bec8ef8e&scoped=true"
import script from "./analytics.vue?vue&type=script&lang=js"
export * from "./analytics.vue?vue&type=script&lang=js"
import style0 from "./analytics.vue?vue&type=style&index=0&id=bec8ef8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec8ef8e",
  null
  
)

export default component.exports